import { addDays, isValid, startOfWeek } from 'date-fns';

import { fromIsoDate, toIsoDate } from '../date/format';

// Parse string to a valid date. If invalid, return default date
export function getValidDate(dateTime: Date | string | null | undefined, defaultDate: Date): Date {
  const date = dateTime ? new Date(dateTime) : defaultDate;
  return isValid(date) ? date : defaultDate;
}

// Parse a string in date only ISO-8601 short date format 'YYYY-MM-DD'
// Return: A valid start of week in ISO-8601 short date format
export function getValidStartOfWeek(dateOnlyString?: string | null, defaultDate?: Date): string {
  const isoDate = dateOnlyString ? fromIsoDate(dateOnlyString) : null;
  const startDate = startOfWeek(getValidDate(isoDate, defaultDate ?? new Date()));
  return toIsoDate(startDate);
}

// Add days to a string in date only ISO-8601 short date format 'YYYY-MM-DD'
// Return: date only string in ISO-8601 short date format
export function addIsoDays(dateOnlyString: string, daysToAdd: number): string {
  const isoDate = fromIsoDate(dateOnlyString);
  return toIsoDate(addDays(isoDate, daysToAdd));
}
